import { createFileRoute } from '@tanstack/react-router'
import ConceptOverview from 'Concept/components/Concept/Sections/ConceptOverview/ConceptOverview'

export const Route = createFileRoute('/concept/$conceptId/')({
    component: ConceptOverview,
})
